import { useEffect, useRef } from "react";
import type { UseInitialSidebarLandingArgs } from "./types";

// Runs once per load; the wrapper mounts the sidebar only after all data is loaded.
export const useInitialSidebarLanding = ({
  sidebarMode,
  planRecords,
  selectedPlanRecordIndex,
  diagramRecords,
  onPlanFilterChange,
  onSidebarModeChange,
}: UseInitialSidebarLandingArgs): void => {
  const hasResolvedLandingRef = useRef(false);

  useEffect(() => {
    if (hasResolvedLandingRef.current) return;
    hasResolvedLandingRef.current = true;

    if (sidebarMode !== "plans") return;

    const selectedRecord =
      selectedPlanRecordIndex !== null
        ? planRecords[selectedPlanRecordIndex]
        : undefined;

    if (selectedRecord) {
      // Land on the tab the selected plan's row lives in.
      onPlanFilterChange(
        selectedRecord.archivedAt !== null ? "archived" : "active",
      );
      return;
    }

    if (planRecords.length === 0 && diagramRecords.length > 0) {
      onSidebarModeChange("diagrams");
    }
  }, [
    sidebarMode,
    selectedPlanRecordIndex,
    planRecords,
    diagramRecords,
    onPlanFilterChange,
    onSidebarModeChange,
  ]);
};
